$(function() {

$("a.scrollto").click(function () {
  var target = $(this).attr("href");
  var destination = $(target).offset().top - 70;
  jQuery("html:not(:animated),body:not(:animated)").animate({scrollTop:destination },900);
  return false;
});

});jQuery(function(){
var stickyMnEl = document.querySelector('.sticky-menu');
var navSticky = document.querySelector('.site-header');
stickyMnEl.addEventListener('click',function(){
  navSticky.classList.toggle('active');
  $('html').toggleClass('noscroll');
});
/*document.addEventListener('click',function(e){
  console.log(e.target.classList);
  if(e.target.classList.contains('sticky')&&e.target.classList.contains('active')){
    navSticky.classList.remove('active');
    $('html').removeClass('noscroll');
  }
});*/

var stickyNavTop;
var desktopEl = jQuery('.site-header');
var desktopElHe = desktopEl.outerHeight();
if(window.innerWidth <= 990) stickyNavTop = jQuery('#PageContainer').offset().top;//jQuery('.site-nav-mobile').offset().top;
else{stickyNavTop = jQuery('#PageContainer').offset().top;}

 var stickyNav = function(){
  var scrollTop = jQuery(window).scrollTop();

  if ((scrollTop > stickyNavTop) || $('html').hasClass('noscroll')){
      desktopEl.addClass('sticky');
      jQuery('body').css('padding-top',desktopElHe).addClass('sticked');
  }else{
    desktopEl.removeClass('sticky');
    desktopElHe = desktopEl.outerHeight();
    jQuery('body').css('padding-top',0).removeClass('sticked');
  }
};
stickyNav();
jQuery(window).scroll(function(){stickyNav()});

$('.popup-cart').mousedown(function(e) {
  var clicked = $(e.target);
  if (clicked.is('.popup-inner')||clicked.parents().is('.popup-inner')){
    return;
  }else{
    $('.popup-cart').fadeOut(350);
    
  }
});
jQuery(document.body).on('afterCartLoad.ajaxCart',function(e){$('[data-popup="popup-cart"]').fadeIn(350);
});
});